import type { PassedPartialValidationEventDetail } from '@stopen-helpers/static'
import { Dispatch, SetStateAction } from 'react'
import { ValidationError } from 'yup'

/**
 * @description
 * takes the Event object from a PASSED_PARTIAL event and clears the errors array
 * if there are no errors related to this fieldName
 * @memberof ValidationMessage
 * */
export const onPassedPartialValidation = (
    event: CustomEvent<PassedPartialValidationEventDetail>,
    formId: string,
    fieldNames: string | string[],
    setValidationErrors: Dispatch<SetStateAction<ValidationError[]>>,
) => {
    if (formId !== event.detail.formId) {
        return
    }
    const fields = typeof fieldNames === 'string' ? [fieldNames] : fieldNames
    const fieldWasValidated = event.detail.validatedFields.some(
        (validatedField) => !!fields?.some((name: string) => name === validatedField),
    )
    if (!fieldWasValidated) {
        return
    }
    setValidationErrors([])
}
